// extracted by mini-css-extract-plugin
module.exports = {"inputRow":"General_inputRow__3SgXM","buttonsWrapper":"General_buttonsWrapper__2yoe0","highlight":"General_highlight__3iw0I","statusText":"General_statusText__P08NU"};